"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var query = require("../query");
var request_animation_frame_1 = require("./request-animation-frame");
function scrollTo(selected, scrollParent) {
    var offset = query.offset(selected), poff = { top: 0, left: 0 }, list, listScrollTop, selectedTop, isWin, selectedHeight, listHeight, bottom;
    if (!selected)
        return;
    list = scrollParent || query.scrollParent(selected);
    isWin = query.getWindow(list);
    listScrollTop = query.getScrollTop(list);
    listHeight = query.height(list, true);
    isWin = query.getWindow(list);
    if (!isWin)
        poff = query.offset(list);
    offset = {
        top: offset.top - poff.top,
        left: offset.left - poff.left,
        height: offset.height,
        width: offset.width
    };
    selectedHeight = offset.height;
    selectedTop = offset.top + (isWin ? 0 : listScrollTop);
    bottom = selectedTop + selectedHeight;
    listScrollTop = listScrollTop > selectedTop
        ? selectedTop
        : bottom > (listScrollTop + listHeight)
            ? (bottom - listHeight)
            : listScrollTop;
    var id = request_animation_frame_1.requestAnimationFrame(function () { return query.setScrollTop(list, listScrollTop); });
    return function () { return request_animation_frame_1.requestAnimationFrame.cancel(id); };
}
exports.scrollTo = scrollTo;



//////////////////
// WEBPACK FOOTER
// ./node_modules/adp-react-components/lib/util/dom-helpers/util/scroll-to.js
// module id = 204
// module chunks = 0 1 2 3 4 5 6